// Libraries
var React = require('react');
var PubSub = require('pubsub-js');

// Components
var SearchBarDesktop = require('./SearchBarDesktop');
var SearchOverlay = require('./SearchOverlay');
var CountryOverlay = require('CountrySelect/CountrySelectOverlay');
var RestrictTab = require('Accessibility/RestrictTab');

var debounce = require('lodash/debounce');

// Styles
require('./SearchDesktopModule.scss');

class SearchModule extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			isOverlayOpen: false,
			isCountryOverlayOpen: false
		};

		this.RestrictTab = new RestrictTab();

		this.bodyScrollSettings = { reserveScrollBarGap: true };

	}

	componentDidMount() {

		if (typeof window === "undefined") return;
	
		let debouncedFunc = debounce(() => {
			
			if (
				this.state.isOverlayOpen &&
				window.matchMedia("(max-width: 999px)").matches
			) {

				this.setState({
					isOverlayOpen: !this.state.isOverlayOpen
				}, () => {
		
					this.hideOverlay();
		
				});

			}

		}, 1000);

		window.addEventListener('resize', debouncedFunc);

	}

	getScrollBarWidth = () => {

		let outer = document.createElement('div');
		outer.style.visibility = 'hidden';
		outer.style.overflow = 'scroll';
		outer.style.msOverflowStyle = 'scrollbar';
		document.body.appendChild(outer);
		let inner = document.createElement('div');
		outer.appendChild(inner);
		let scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
		outer.parentNode.removeChild(outer);
		return scrollbarWidth + 'px';

	}

	toggleOverlay = () => {

		this.setState({
			isOverlayOpen: !this.state.isOverlayOpen
		}, () => {

			if (this.state.isOverlayOpen) {

				this.showOverlay();
				return;
	
			}

			this.hideOverlay();

		});

		PubSub.publish('OverlayToggled', !this.state.isOverlayOpen);

	};

	getOverlayElements = () => {

		return {
			scrollableElement: document.querySelector('.SearchOverlay'),
			searchBarDesktop: document.querySelector('.SearchBarDesktop')
		};

	}

	showOverlay = () => {

		const overlayElements = this.getOverlayElements();
		if (!overlayElements.scrollableElement || !overlayElements.searchBarDesktop) return;

		document.querySelector('html').classList.add('search-overlay-open');

		if (window['bodyScrollLock']) {
			
			const scrollBarWidth = this.getScrollBarWidth();
			overlayElements.searchBarDesktop.style.paddingRight = scrollBarWidth;
			window['bodyScrollLock'].disableBodyScroll(overlayElements.scrollableElement, this.bodyScrollSettings);

		}

	}

	hideOverlay = () => {

		const overlayElements = this.getOverlayElements();
		if (!overlayElements.scrollableElement || !overlayElements.searchBarDesktop) return;

		document.querySelector('html').classList.remove('search-overlay-open');

		if (window['bodyScrollLock']) {

			overlayElements.searchBarDesktop.style.paddingRight = '0';
			window['bodyScrollLock'].enableBodyScroll(overlayElements.scrollableElement, this.bodyScrollSettings);

		}

	}

	toggleCountryOverlay = () => {
		// Disable scrolling.
		document.querySelector('body').classList.toggle('navigation-open');

		if(!this.state.isCountryOverlayOpen) {
			this.RestrictTab.setup('.js-country-start-tab', '.js-country-end-tab');
		} else {
			this.RestrictTab.destroy();
		}

		this.setState({
			isCountryOverlayOpen: !this.state.isCountryOverlayOpen
		});

		PubSub.publish('OverlayToggled', !this.state.isCountryOverlayOpen);
	};

	render() {
		return (
			<div className="SearchDesktop">
				<SearchBarDesktop toggleOverlay={this.toggleOverlay} toggleCountryOverlay={this.toggleCountryOverlay} logonLinks={this.props.data.logonLinks} accessibilityLink={this.props.data.accessibilityLink} subscribeLink={this.props.data.subscribeLink} stadiumSiteLink={this.props.data.stadiumSiteLink} />
				<SearchOverlay toggleOverlay={this.toggleOverlay} isOverlayOpen={this.state.isOverlayOpen} data={this.props.data}/>
				<CountryOverlay toggleCountryOverlay={this.toggleCountryOverlay} isCountryOverlayOpen={this.state.isCountryOverlayOpen} data={this.props.data}/>
			</div>
		)
	}
}

module.exports = SearchModule;



// WEBPACK FOOTER //
// ./src/components/Search/SearchDesktop/SearchDesktopModule.js